/**
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH
 * under one or more contributor license agreements. See the NOTICE file
 * distributed with this work for additional information regarding copyright
 * ownership.
 *
 * Camunda licenses this file to you under the MIT; you may not use this file
 * except in compliance with the MIT License.
 */

import {
  isString
} from 'min-dash';

import { getFormJSVersion } from './config/formVersion';
import { getRuleConfig } from './config/ruleConfig';
import { getExecutionPlatformLabel } from './config/util';
import { defaultRuleRegistry } from './rules/ruleRegistry';
import { executeRecursively } from './util';
import StaticRuleResolver from './StaticRuleResolver';
import ProblemsReporter from './ProblemsReporter';

export class FormLinter {
  lint(contents) {

    const schema = isString(contents) ? JSON.parse(contents) : contents;
    const formJSVersion = getFormJSVersion(schema);

    if (!formJSVersion) {
      return [];
    }

    const executionPlatformLabel = getExecutionPlatformLabel(schema);
    const ruleResolver = new StaticRuleResolver(defaultRuleRegistry);
    const rules = ruleResolver.resolve(getRuleConfig(formJSVersion));
    const reporter = new ProblemsReporter();

    const baseContext = {
      executionPlatformLabel,
      formJSVersion,
      reporter
    };

    rules.forEach(rule => {

      const context = {
        ...baseContext,
        category: rule.category
      };

      executeRecursively(rule.execute, schema, context);

    });

    return reporter.getReports();
  }
}

